import { ref } from 'vue';

/**
 * Reactive label used to override the last breadcrumb crumb for routes that
 * resolve their title dynamically (e.g. entity detail pages). Set it once the
 * entity is loaded and clear it when leaving the page.
 */
export const dynamicBreadcrumbLabel = ref<string | null>(null);

export function setBreadcrumbLabel(label: string): void {
  dynamicBreadcrumbLabel.value = label;
}

export function clearBreadcrumbLabel(): void {
  dynamicBreadcrumbLabel.value = null;
}
